// Package billing.v3 defines the protocol buffer messages for billing subscription management
// within the platform. This includes subscription lifecycle, billing cycles, and
// subscription-related billing operations.

// @generated by protoc-gen-es v2.2.5 with parameter "target=ts"
// @generated from file billing/v3/subscription.proto (package billing.v3, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_common_v3_common } from "../../common/v3/common_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file billing/v3/subscription.proto.
 */
export const file_billing_v3_subscription: GenFile = /*@__PURE__*/
  fileDesc("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", [file_common_v3_common, file_google_protobuf_timestamp]);

/**
 * Subscription represents an active subscription for a customer.
 * It contains all the details about the subscription including billing cycles, status, and plan association.
 * This is provider-agnostic and integrates with our internal Plan system.
 *
 * @generated from message billing.v3.Subscription
 */
export type Subscription = Message<"billing.v3.Subscription"> & {
  /**
   * ID is the unique identifier for this subscription
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * UserID is the ID of the user who owns this subscription
   *
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * PlanID is the ID of our internal plan this subscription is associated with
   *
   * @generated from field: string plan_id = 3;
   */
  planId: string;

  /**
   * ProviderID is the external payment provider subscription ID (e.g., Stripe subscription ID)
   *
   * @generated from field: string provider_id = 4;
   */
  providerId: string;

  /**
   * ProviderName is the name of the payment provider (e.g., "stripe")
   *
   * @generated from field: string provider_name = 5;
   */
  providerName: string;

  /**
   * Status indicates the current state of the subscription
   *
   * @generated from field: billing.v3.SubscriptionStatus status = 6;
   */
  status: SubscriptionStatus;

  /**
   * CurrentPeriodEnd is when the current billing period ends (essential for access control)
   *
   * @generated from field: google.protobuf.Timestamp current_period_end = 7;
   */
  currentPeriodEnd: Timestamp;

  /**
   * CancelAt is when the subscription will be automatically canceled (null if not scheduled)
   *
   * @generated from field: google.protobuf.Timestamp cancel_at = 8;
   */
  cancelAt: Timestamp;

  /**
   * Metadata contains custom key-value pairs for this subscription
   *
   * @generated from field: map<string, string> metadata = 23;
   */
  metadata: { [key: string]: string };

  /**
   * CreatedAt is when this subscription record was created
   *
   * @generated from field: google.protobuf.Timestamp created_at = 24;
   */
  createdAt?: Timestamp;

  /**
   * ModifiedAt is when this subscription was last modified
   *
   * @generated from field: google.protobuf.Timestamp modified_at = 25;
   */
  modifiedAt?: Timestamp;

  /**
   * ModifiedBy is the user responsible for the last modification
   *
   * @generated from field: string modified_by = 26;
   */
  modifiedBy: string;

  /**
   * TenantID is the ID of the tenant this subscription belongs to
   *
   * @generated from field: string tenant_id = 27;
   */
  tenantId: string;

  /**
   * OrganizationID is the ID of the organization this subscription belongs to
   *
   * @generated from field: string organization_id = 28;
   */
  organizationId: string;
};

/**
 * Describes the message billing.v3.Subscription.
 * Use `create(SubscriptionSchema)` to create a new message.
 */
export const SubscriptionSchema: GenMessage<Subscription> = /*@__PURE__*/
  messageDesc(file_billing_v3_subscription, 0);

/**
 * CreateSubscriptionRequest contains parameters for creating subscriptions
 *
 * @generated from message billing.v3.CreateSubscriptionRequest
 */
export type CreateSubscriptionRequest = Message<"billing.v3.CreateSubscriptionRequest"> & {
  /**
   * UserID is the ID of the user to create the subscription for
   *
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * PlanID is the ID of our internal plan this subscription is associated with
   *
   * @generated from field: string plan_id = 2;
   */
  planId: string;

  /**
   * ProviderID is the external payment provider subscription ID
   *
   * @generated from field: string provider_id = 3;
   */
  providerId: string;

  /**
   * ProviderName is the name of the payment provider
   *
   * @generated from field: string provider_name = 4;
   */
  providerName: string;

  /**
   * Metadata contains custom key-value pairs for this subscription
   *
   * @generated from field: map<string, string> metadata = 10;
   */
  metadata: { [key: string]: string };

  /**
   * TenantID is the ID of the tenant this subscription belongs to
   *
   * @generated from field: string tenant_id = 11;
   */
  tenantId: string;

  /**
   * OrganizationID is the ID of the organization this subscription belongs to
   *
   * @generated from field: string organization_id = 12;
   */
  organizationId: string;

  /**
   * IdempotencyKey ensures that multiple requests with the same key are processed only once
   *
   * @generated from field: optional string idempotency_key = 14;
   */
  idempotencyKey?: string;

  /**
   * CurrentPeriodEnd is when the current billing period ends (optional, will use default if not provided)
   *
   * @generated from field: optional google.protobuf.Timestamp current_period_end = 15;
   */
  currentPeriodEnd: Timestamp;

  /**
   * CancelAt is when the subscription will be automatically canceled (optional)
   *
   * @generated from field: optional google.protobuf.Timestamp cancel_at = 16;
   */
  cancelAt: Timestamp;
};

/**
 * Describes the message billing.v3.CreateSubscriptionRequest.
 * Use `create(CreateSubscriptionRequestSchema)` to create a new message.
 */
export const CreateSubscriptionRequestSchema: GenMessage<CreateSubscriptionRequest> = /*@__PURE__*/
  messageDesc(file_billing_v3_subscription, 1);

/**
 * UpdateSubscriptionRequest contains parameters for updating subscriptions
 *
 * @generated from message billing.v3.UpdateSubscriptionRequest
 */
export type UpdateSubscriptionRequest = Message<"billing.v3.UpdateSubscriptionRequest"> & {
  /**
   * ID is the unique identifier for the subscription to update
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * CancelAt schedules when the subscription will be automatically canceled
   *
   * @generated from field: optional google.protobuf.Timestamp cancel_at = 2;
   */
  cancelAt: Timestamp;

  /**
   * Metadata contains custom key-value pairs to update
   *
   * @generated from field: map<string, string> metadata = 3;
   */
  metadata: { [key: string]: string };

  /**
   * UserID is the user responsible for the update
   *
   * @generated from field: string user_id = 4;
   */
  userId: string;

  /**
   * CurrentPeriodEnd updates when the current billing period ends
   *
   * @generated from field: optional google.protobuf.Timestamp current_period_end = 5;
   */
  currentPeriodEnd?: Timestamp;

  /**
   * Status updates the subscription status
   *
   * @generated from field: optional billing.v3.SubscriptionStatus status = 6;
   */
  status: SubscriptionStatus;
};

/**
 * Describes the message billing.v3.UpdateSubscriptionRequest.
 * Use `create(UpdateSubscriptionRequestSchema)` to create a new message.
 */
export const UpdateSubscriptionRequestSchema: GenMessage<UpdateSubscriptionRequest> = /*@__PURE__*/
  messageDesc(file_billing_v3_subscription, 2);

/**
 * CancelSubscriptionRequest contains parameters for canceling subscriptions
 *
 * @generated from message billing.v3.CancelSubscriptionRequest
 */
export type CancelSubscriptionRequest = Message<"billing.v3.CancelSubscriptionRequest"> & {
  /**
   * ID is the unique identifier for the subscription to cancel
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * AtPeriodEnd determines whether to cancel immediately or at period end
   *
   * @generated from field: bool at_period_end = 2;
   */
  atPeriodEnd: boolean;

  /**
   * UserID is the user canceling this subscription
   *
   * @generated from field: string user_id = 3;
   */
  userId: string;
};

/**
 * Describes the message billing.v3.CancelSubscriptionRequest.
 * Use `create(CancelSubscriptionRequestSchema)` to create a new message.
 */
export const CancelSubscriptionRequestSchema: GenMessage<CancelSubscriptionRequest> = /*@__PURE__*/
  messageDesc(file_billing_v3_subscription, 3);

/**
 * ListSubscriptionsRequest contains parameters for listing subscriptions
 *
 * @generated from message billing.v3.ListSubscriptionsRequest
 */
export type ListSubscriptionsRequest = Message<"billing.v3.ListSubscriptionsRequest"> & {
  /**
   * UserID filters subscriptions by user ID
   *
   * @generated from field: optional string user_id = 1;
   */
  userId: string;

  /**
   * PlanID filters subscriptions by plan ID
   *
   * @generated from field: optional string plan_id = 2;
   */
  planId: string;

  /**
   * Status filters subscriptions by status
   *
   * @generated from field: optional billing.v3.SubscriptionStatus status = 3;
   */
  status?: SubscriptionStatus;

  /**
   * ProviderName filters subscriptions by provider name
   *
   * @generated from field: optional string provider_name = 4;
   */
  providerName: string;

  /**
   * TenantID filters subscriptions by tenant
   *
   * @generated from field: optional string tenant_id = 5;
   */
  tenantId: string;

  /**
   * Limit specifies the maximum number of subscriptions to return
   *
   * @generated from field: int64 limit = 6;
   */
  limit: bigint;

  /**
   * StartAfter is a subscription ID for cursor-based pagination
   *
   * @generated from field: optional string start_after = 7;
   */
  startAfter: string;
};

/**
 * Describes the message billing.v3.ListSubscriptionsRequest.
 * Use `create(ListSubscriptionsRequestSchema)` to create a new message.
 */
export const ListSubscriptionsRequestSchema: GenMessage<ListSubscriptionsRequest> = /*@__PURE__*/
  messageDesc(file_billing_v3_subscription, 4);

/**
 * GetSubscriptionsByTenantRequest contains parameters for listing subscriptions by tenant
 *
 * @generated from message billing.v3.GetSubscriptionsByTenantRequest
 */
export type GetSubscriptionsByTenantRequest = Message<"billing.v3.GetSubscriptionsByTenantRequest"> & {
  /**
   * TenantID filters subscriptions by tenant
   *
   * @generated from field: string tenant_id = 1;
   */
  tenantId: string;

  /**
   * Limit specifies the maximum number of subscriptions to return
   *
   * @generated from field: int64 limit = 2;
   */
  limit: bigint;
};

/**
 * Describes the message billing.v3.GetSubscriptionsByTenantRequest.
 * Use `create(GetSubscriptionsByTenantRequestSchema)` to create a new message.
 */
export const GetSubscriptionsByTenantRequestSchema: GenMessage<GetSubscriptionsByTenantRequest> = /*@__PURE__*/
  messageDesc(file_billing_v3_subscription, 5);

/**
 * GetSubscriptionsByUserRequest contains parameters for listing subscriptions by user
 *
 * @generated from message billing.v3.GetSubscriptionsByUserRequest
 */
export type GetSubscriptionsByUserRequest = Message<"billing.v3.GetSubscriptionsByUserRequest"> & {
  /**
   * UserID filters subscriptions by user
   *
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * Limit specifies the maximum number of subscriptions to return
   *
   * @generated from field: int64 limit = 2;
   */
  limit: bigint;
};

/**
 * Describes the message billing.v3.GetSubscriptionsByUserRequest.
 * Use `create(GetSubscriptionsByUserRequestSchema)` to create a new message.
 */
export const GetSubscriptionsByUserRequestSchema: GenMessage<GetSubscriptionsByUserRequest> = /*@__PURE__*/
  messageDesc(file_billing_v3_subscription, 6);

/**
 * GetSubscriptionsByPlanRequest contains parameters for listing subscriptions by plan
 *
 * @generated from message billing.v3.GetSubscriptionsByPlanRequest
 */
export type GetSubscriptionsByPlanRequest = Message<"billing.v3.GetSubscriptionsByPlanRequest"> & {
  /**
   * PlanID filters subscriptions by plan
   *
   * @generated from field: string plan_id = 1;
   */
  planId: string;

  /**
   * Limit specifies the maximum number of subscriptions to return
   *
   * @generated from field: int64 limit = 2;
   */
  limit: bigint;
};

/**
 * Describes the message billing.v3.GetSubscriptionsByPlanRequest.
 * Use `create(GetSubscriptionsByPlanRequestSchema)` to create a new message.
 */
export const GetSubscriptionsByPlanRequestSchema: GenMessage<GetSubscriptionsByPlanRequest> = /*@__PURE__*/
  messageDesc(file_billing_v3_subscription, 7);

/**
 * UserSubscription represents a simplified subscription view for user authentication responses.
 * This message includes essential subscription and plan information needed by the frontend.
 *
 * @generated from message billing.v3.UserSubscription
 */
export type UserSubscription = Message<"billing.v3.UserSubscription"> & {
  /**
   * ID is the unique identifier for this subscription
   *
   * @generated from field: string subscription_id = 1;
   */
  subscriptionId: string;

  /**
   * PlanType represents the plan tier (e.g., "free.v1", "pro.v1", "team.v1")
   *
   * @generated from field: string plan_type = 2;
   */
  planType: string;

  /**
   * PlanName is the display name of the plan (e.g., "Free", "Pro", "Team")
   *
   * @generated from field: string plan_name = 3;
   */
  planName: string;

  /**
   * Status indicates the current state of the subscription
   *
   * @generated from field: billing.v3.SubscriptionStatus status = 4;
   */
  status: SubscriptionStatus;

  /**
   * BillingInterval represents the billing frequency (monthly, yearly, etc.)
   *
   * @generated from field: billing.v3.BillingInterval billing_interval = 5;
   */
  billingInterval: BillingInterval;

  /**
   * CurrentPeriodEnd is when the current billing period ends
   *
   * @generated from field: google.protobuf.Timestamp current_period_end = 6;
   */
  currentPeriodEnd?: Timestamp;

  /**
   * CancelAt is when the subscription will be automatically canceled (optional)
   *
   * @generated from field: optional google.protobuf.Timestamp cancel_at = 7;
   */
  cancelAt?: Timestamp;

  /**
   * IsTrialing indicates if the subscription is in trial period
   *
   * @generated from field: bool is_trialing = 8;
   */
  isTrialing: boolean;

  /**
   * ProductType represents the specific product variant (e.g., "pro_monthly", "team_yearly")
   *
   * @generated from field: string product_type = 9;
   */
  productType: string;
};

/**
 * Describes the message billing.v3.UserSubscription.
 * Use `create(UserSubscriptionSchema)` to create a new message.
 */
export const UserSubscriptionSchema: GenMessage<UserSubscription> = /*@__PURE__*/
  messageDesc(file_billing_v3_subscription, 8);

/**
 * SubscriptionStatus represents the current state of a subscription.
 * These statuses help track the subscription lifecycle and billing state.
 *
 * @generated from enum billing.v3.SubscriptionStatus
 */
export enum SubscriptionStatus {
  /**
   * @generated from enum value: SUBSCRIPTION_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Active indicates the subscription is current and paid
   *
   * @generated from enum value: SUBSCRIPTION_STATUS_ACTIVE = 1;
   */
  ACTIVE = 1,

  /**
   * Past due indicates payment is overdue but subscription is still active
   *
   * @generated from enum value: SUBSCRIPTION_STATUS_PAST_DUE = 2;
   */
  PAST_DUE = 2,

  /**
   * Unpaid indicates the subscription has unpaid invoices
   *
   * @generated from enum value: SUBSCRIPTION_STATUS_UNPAID = 3;
   */
  UNPAID = 3,

  /**
   * Canceled indicates the subscription has been canceled
   *
   * @generated from enum value: SUBSCRIPTION_STATUS_CANCELED = 4;
   */
  CANCELED = 4,

  /**
   * Incomplete indicates the initial payment failed
   *
   * @generated from enum value: SUBSCRIPTION_STATUS_INCOMPLETE = 5;
   */
  INCOMPLETE = 5,

  /**
   * Incomplete expired indicates incomplete subscription has expired
   *
   * @generated from enum value: SUBSCRIPTION_STATUS_INCOMPLETE_EXPIRED = 6;
   */
  INCOMPLETE_EXPIRED = 6,

  /**
   * Trialing indicates the subscription is in trial period
   *
   * @generated from enum value: SUBSCRIPTION_STATUS_TRIALING = 7;
   */
  TRIALING = 7,

  /**
   * Paused indicates the subscription has been temporarily paused
   *
   * @generated from enum value: SUBSCRIPTION_STATUS_PAUSED = 8;
   */
  PAUSED = 8,
}

/**
 * Describes the enum billing.v3.SubscriptionStatus.
 */
export const SubscriptionStatusSchema: GenEnum<SubscriptionStatus> = /*@__PURE__*/
  enumDesc(file_billing_v3_subscription, 0);

/**
 * BillingInterval represents the billing frequency for subscription plans.
 * This determines how often customers are charged for their subscription.
 *
 * @generated from enum billing.v3.BillingInterval
 */
export enum BillingInterval {
  /**
   * @generated from enum value: BILLING_INTERVAL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Day bills customers daily
   *
   * @generated from enum value: BILLING_INTERVAL_DAY = 1;
   */
  DAY = 1,

  /**
   * Week bills customers weekly
   *
   * @generated from enum value: BILLING_INTERVAL_WEEK = 2;
   */
  WEEK = 2,

  /**
   * Month bills customers monthly
   *
   * @generated from enum value: BILLING_INTERVAL_MONTH = 3;
   */
  MONTH = 3,

  /**
   * Year bills customers yearly
   *
   * @generated from enum value: BILLING_INTERVAL_YEAR = 4;
   */
  YEAR = 4,
}

/**
 * Describes the enum billing.v3.BillingInterval.
 */
export const BillingIntervalSchema: GenEnum<BillingInterval> = /*@__PURE__*/
  enumDesc(file_billing_v3_subscription, 1);

/**
 * CollectionMethod determines how invoices are collected
 *
 * @generated from enum billing.v3.CollectionMethod
 */
export enum CollectionMethod {
  /**
   * @generated from enum value: COLLECTION_METHOD_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Charge automatically charges the customer's default payment method
   *
   * @generated from enum value: COLLECTION_METHOD_CHARGE_AUTOMATICALLY = 1;
   */
  CHARGE_AUTOMATICALLY = 1,

  /**
   * Send invoice sends an invoice that the customer pays manually
   *
   * @generated from enum value: COLLECTION_METHOD_SEND_INVOICE = 2;
   */
  SEND_INVOICE = 2,
}

/**
 * Describes the enum billing.v3.CollectionMethod.
 */
export const CollectionMethodSchema: GenEnum<CollectionMethod> = /*@__PURE__*/
  enumDesc(file_billing_v3_subscription, 2);

